/**
 * Auth Module
 */
import { users } from './data';
import axios from 'axios'

const state = {
    users: null,
    loadingChatModule: false,
    selectedUser: null,
    loadingChat: false,
    chatSidebar: false,
    chatFilterStatus: 'open',
    chatFilterDepartment: 'Hepsi'
}

// getters
const getters = {
    loadingChatModule: state => {
        return state.loadingChatModule
    },
    users: state => {
        return state.users
    },
    selectedUser: state => {
        return state.selectedUser
    },
    loadingChat: state => {
        return state.loadingChat
    },
    chatSidebar: state => {
        return state.chatSidebar
    },
    chatFilterDepartment: state => {
        return state.chatFilterDepartment
    },
    chatFilterStatus: state => {
        return state.chatFilterStatus
    }

}

// actions
const actions = {
    async getUsers(context) {
        context.commit('getUsers');
        console.log(context.state.users);
        if (context.state.users !== null) {
            console.log(context.state.users)
            context.state.users.map(({id}) => {
                this._vm.$echo.leave('supportmessage.' + id)
            })
        }
        const department_id = context.state.chatFilterDepartment === 'Teknik Destek' ? 1 : context.state.chatFilterDepartment === 'Muhasebe' ? 2 : 3;
        const {data} = await axios.post('admin/support/get', {
            department_id : context.state.chatFilterDepartment === 'Teknik Destek' ? 1 : 2, // teknik destek ise 1
            all: (department_id > 2),
            filter: context.state.chatFilterStatus
        });
        data.map(({id}) => {
            this._vm.$echo.private('supportmessage.' + id)
            .listen('SupportMessage', (r) => {
                context.commit('sendMessage', r)
                if(r.status.id === 'closed') {
                    context.state.selectedUser.status = 'closed';
                }
            })
        })
        context.commit('getUserSuccess', data);
    },
    openChat(context, payload) {
        context.commit('loadChat', payload);
        setTimeout(() => {
            context.commit('loadChatSuccess');
        }, 500);
    },
    sendMessage(context, payload) {
        context.commit('sendMessage', payload)
    },
    toggleChatSidebar(context, payload) {
        context.commit('toggleChatSidebarHandler', payload);
    },
    setChatFilterStatus(context, payload) {
        context.commit('setChatFilterStatusHandler', payload);
        context.dispatch('getUsers');
    },
    setChatFilterDepartment(context, payload) {
        context.commit('setFilterHandler', payload);
        context.dispatch('getUsers');
    }
}

// mutations
const mutations = {
    getUsers(state) {
        state.loadingChatModule = true;
    },
    getUserSuccess(state, data) {
       // state.users = users;
        state.users = data.map(item => {
            item.selected=false;
            return item;
        });
        state.loadingChatModule = false;
    },
    loadChat(state, user) {
        state.loadingChat = true
        state.selectedUser = user
        for (let i = 0; i < state.users.length; i++) {
            let selectedUser = state.users[i];
            if (selectedUser.id === user.id) {
                state.users[i].selected = true
                state.chatSidebar = false
            } else {
                state.users[i].selected = false
            }
        }
    },
    loadChatSuccess(state) {
        state.loadingChat = false
    },
    sendMessage(state, message) {
        for (let i = 0; i < state.users.length; i++) {
            let user = state.users[i];
            if (user.id === message.support_request_id) {
                state.users[i].messages.push(message)
            }
        }
    },
    toggleChatSidebarHandler(state, val) {
        state.chatSidebar = val;
    },
    setChatFilterStatusHandler(state, val) {
        state.chatFilterStatus = val;
        state.selectedUser = null;
    },
    setFilterHandler(state, val) {
        state.chatFilterDepartment = val;
        state.selectedUser = null;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
